import PublicLayout from './PublicLayout/PublicLayout';
import AuthenticationLayout from './AdminLayout/AuthenticationLayout/AuthenticationLayout';
import MainLayout from './AdminLayout/MainLayout/MainLayout';

export {
	PublicLayout,
	AuthenticationLayout,
	MainLayout
}